module.exports = __webpack_public_path__ + "static/media/bg-5.7b3da4c3.jpg";